'use client';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';
import getDistinctFacetsAsQueryString from './helpers/getDistinctFacetsAsQueryString';
import getRangeFacetsAsQueryString from './helpers/getRangeFacetsAsQueryString';
import useShallowSearchParams from './useShallowSearchParams';
import { getPathnameWithoutPageNumber } from '@utils/slug/getPathnameWithoutPageNumber';

export const useFacetPrice = () => {
  const pathname = usePathname();
  const route = useRouter();
  const searchParams = useSearchParams();
  const { shallowSearchParams, setShallowSearchParams } =
    useShallowSearchParams();
  const pathnameWithoutPageNumber = getPathnameWithoutPageNumber(pathname);

  return (
    value:
      | { type: 'range'; min: number; max: number }
      | { type: 'range'; min: null; max: null },
  ) => {
    const searchQuerySearchParam = searchParams.get('query');
    const relevantSearchParams = new URLSearchParams(shallowSearchParams);
    if (searchQuerySearchParam) {
      relevantSearchParams.set('query', searchQuerySearchParam);
    }
    const priceFacetSearchParams = getRangeFacetsAsQueryString({
      searchParams: relevantSearchParams,
      value,
    });

    const href = `${pathnameWithoutPageNumber}?${priceFacetSearchParams}`;
    setShallowSearchParams(href, priceFacetSearchParams);
    route.replace(`${pathnameWithoutPageNumber}?${priceFacetSearchParams}`, {
      scroll: false,
    });
  };
};

export default function useFacetsSort() {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const { shallowSearchParams, setShallowSearchParams } =
    useShallowSearchParams();
  const pathnameWithoutPageNumber = getPathnameWithoutPageNumber(pathname);

  return (value: { id: string; name: string }) => {
    const searchQuerySearchParam = searchParams.get('query');
    const relevantSearchParams = new URLSearchParams(shallowSearchParams);
    if (searchQuerySearchParam) {
      relevantSearchParams.set('query', searchQuerySearchParam);
    }

    const distinctSearchParams = getDistinctFacetsAsQueryString({
      id: value.id,
      name: value.name,
      searchParams: relevantSearchParams,
    });

    const href = `${pathnameWithoutPageNumber}?${distinctSearchParams}`;
    setShallowSearchParams(href, distinctSearchParams);
    router.replace(href, {
      scroll: false,
    });
  };
}
